import React from 'react';

import {gt} from 'app/utils/i18n';

import {AssignTaskToUserButton} from './components/UserDetailPage/AssignTaskToUserButton';
import {UpdateGuestExpirationButton} from './components/UserDetailPage/UpdateGuestExpirationButton';
import {BadgeStatusType, getUserStatusBadges} from './users-badges';

import {UserSerializedType} from 'sweet-types';

export interface AlertStatusType extends BadgeStatusType {
  ActionButton?: React.FC<{
    refreshData?: () => unknown;
    user: UserSerializedType;
  }>;
  action: {
    name?: string;
    propName?: 'resendInvitation' | 'disableSaml' | 'enableSaml';
  };
}

export const getUserStatusAlerts = (
  user: UserSerializedType,
  isSaml: boolean
): Array<AlertStatusType> => {
  const badgeStatuses = getUserStatusBadges(user, isSaml);

  return badgeStatuses.map((status) => {
    let ActionButton:
      | undefined
      | React.FC<{
          refreshData?: () => unknown;
          user: UserSerializedType;
        }> = undefined;
    let action = {};
    if (status.badgeType === 'sso_enabled') {
      action = {
        name: gt('Restrict login to email/password'),
        propName: 'disableSaml',
      };
    }
    if (status.badgeType === 'sso_disabled') {
      action = {
        name: gt('Restrict login to SSO'),
        propName: 'enableSaml',
      };
    }
    if (
      status.badgeType === 'invitation_pending' ||
      status.badgeType === 'invalid_email'
    ) {
      action = {
        name: gt('Resend Invitation'),
        propName: 'resendInvitation',
      };
    }
    if (
      status.badgeType === 'guess_access_expired' ||
      status.badgeType === 'guest_expiration_date'
    ) {
      ActionButton = UpdateGuestExpirationButton;
    }
    if (status.badgeType === 'no_tasks') {
      ActionButton = AssignTaskToUserButton;
    }
    return {
      ...status,
      action,
      ActionButton,
    };
  });
};
